export default [{
  icon: "mdi-transit-transfer",
  title: "Api Calls",
  group: "/api-calls",
  children: [
    {
      to: "search",
      title: "Search",
      icon: "mdi-format-list-checks",
    },
    {
      title: "List",
      to: "list",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Report",
      to: "report",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Grouped Report",
      to: "grouped-report",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Realtime Report",
      to: "realtime-report",
      icon: "mdi-format-list-checks",
    },
  ],
}];
